export const GOOGLE_ONE_TAP_EXPERIMENT = 'ABACUS-566';
export const GOOGLE_ONE_TAP_ENABLED_VARIANT = 'B';
export const GOOGLE_ONE_TAP_ENABLE_COOKIE = 'google_one_tap_enabled';

type GoogleOneTapEligibilityInput = {
  clientId?: string;
  experimentVariant?: string;
  isLoggedOut: boolean;
  isWebview: boolean | undefined;
};

export function isGoogleOneTapEnabledByCookie(
  cookie = document.cookie
): boolean {
  return cookie.split(';').some((entry) => {
    return entry.trim() === `${GOOGLE_ONE_TAP_ENABLE_COOKIE}=true`;
  });
}

export function isGoogleOneTapEligible({
  clientId,
  experimentVariant,
  isLoggedOut,
  isWebview,
}: GoogleOneTapEligibilityInput): boolean {
  if (typeof window === 'undefined') return false;

  return Boolean(
    clientId &&
    isLoggedOut &&
    (experimentVariant === GOOGLE_ONE_TAP_ENABLED_VARIANT ||
      isGoogleOneTapEnabledByCookie()) &&
    !isWebview &&
    window.top === window.self
  );
}
